import { createClient } from "@supabase/supabase-js";
import "react-native-url-polyfill/auto";
import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";

const supabaseUrl = process.env.EXPO_PUBLIC_SUPABASE_URL!;
const supabaseKey = process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY!;

if (!supabaseUrl || !supabaseKey) {
  throw new Error("Supabase URL and Key must be set in .env");
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  // global: {
  //   headers: {
  //     "x-client-info": "",
  //     "x-supabase-client": "",
  //   },
  // },
  auth: {
    ...(Platform.OS !== "web" ? { storage: AsyncStorage } : {}),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: Platform.OS === "web",
  },
});

//import 'react-native-url-polyfill/auto'
//import * as SecureStore from 'expo-secure-store'
//import { createClient } from '@supabase/supabase-js'
//
//const ExpoSecureStoreAdapter = {
//  getItem: (key: string) => {
//    return SecureStore.getItemAsync(key)
//  },
//  setItem: (key: string, value: string) => {
//    SecureStore.setItemAsync(key, value)
//  },
//  removeItem: (key: string) => {
//    SecureStore.deleteItemAsync(key)
//  },
//}
//
//const supabaseUrl = process.env.EXPO_PUBLIC_SUPABASE_URL!;
//const supabaseAnonKey = process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY!;
//
//export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
//  auth: {
//    storage: ExpoSecureStoreAdapter,
//    autoRefreshToken: true
//  },
//})
